<template>
    <div class="alignment" id="ALIGN-SWF">
            <div class="content">
                <div class="align"><p>对齐布局</p></div>
                <!--<div class="container">-->
                    <!--<div class="item" v-for="item,index in items">-->
                        <!--<el-tooltip class="item" effect="dark"  placement="top">-->
                            <!--<div :class="{active: item.active}" @click="handleAliginItemClick(index)">-->
                                <!--&lt;!&ndash;<img v-bind:src="baseUrl+'layout_AlignLeft_normal'+lastUrl">&ndash;&gt;-->
                                <!--<img src="./layout_AlignLeft_normal.png">-->
                            <!--</div>-->
                            <!--<p slot="content" class="ddd" >{{item.desc}}</p>-->
                        <!--</el-tooltip>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;分割线&ndash;&gt;-->
                    <!--<div class="line" ></div>-->
                    <!--<div class="align"><p>统一大小</p></div>-->
                    <!--<div class="item" v-for="item,index in item1s">-->
                        <!--<el-tooltip class="item" effect="dark" content="删除" placement="top">-->
                            <!--<div :class="{active: item.active}" @click="handleSizeItemClick(index)">-->
                                <!--<img :src="item.normal">-->
                            <!--</div>-->
                            <!--&lt;!&ndash;<p slot="content" >{{item.desc}}</p>&ndash;&gt;-->
                        <!--</el-tooltip>-->
                    <!--</div>-->
                <!--</div>-->


                <div class="Align_container">
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="左对齐" placement="bottom">
                            <div :class="{active: items[0].active, disabled:items[0].disabled}" @click="handleAliginItemClick(0)">
                                <div v-if="items[0].disabled">
                                    <img src="./layout_AlignLeft_disabled.png">
                                </div>
                                <div v-if="!items[0].disabled">
                                    <img src= "./layout_AlignLeft_normal.png" >
                                </div>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="水平居中对齐" placement="bottom">
                            <div :class="{active: items[1].active, disabled:items[1].disabled}" @click="handleAliginItemClick(1)">
                                <div v-if="items[1].disabled">
                                    <img src="./layout_AlignCenter_disabled.png">
                                </div>
                                <div v-if="!items[1].disabled">
                                    <img src= "./layout_AlignCenter_normal.png" >
                                </div>
                                <!--<img src="./layout_AlignCenter_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="右对齐" placement="bottom">
                            <div :class="{active: items[2].active, disabled:items[2].disabled}" @click="handleAliginItemClick(2)">
                                <div v-if="items[2].disabled">
                                    <img src="./layout_AlignRight_disabled.png">
                                </div>
                                <div v-if="!items[2].disabled">
                                    <img src= "./layout_AlignRight_normal.png" >
                                </div>
                                <!--<img src="./layout_AlignRight_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="水平等距" placement="bottom">
                            <div :class="{active: items[3].active, disabled:items[3].disabled}" @click="handleAliginItemClick(3)">
                                <div v-if="items[3].disabled">
                                    <img src="./layout_AlignJustify_disabled.png">
                                </div>
                                <div v-if="!items[3].disabled">
                                    <img src= "./layout_AlignJustify_normal.png" >
                                </div>
                                <!--<img src="./layout_AlignJustify_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="顶对齐" placement="bottom">
                            <div :class="{active: items[4].active, disabled:items[4].disabled}" @click="handleAliginItemClick(4)">
                                <div v-if="items[4].disabled">
                                    <img src="./layout_ValighTop_disabled.png">
                                </div>
                                <div v-if="!items[4].disabled">
                                    <img src= "./layout_ValighTop_normal.png" >
                                </div>
                                <!--<img src="./layout_ValighTop_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="垂直居中对齐" placement="bottom">
                            <div :class="{active: items[5].active, disabled:items[5].disabled}" @click="handleAliginItemClick(5)">
                                <div v-if="items[5].disabled">
                                    <img src="./layout_ValignMiddle_disabled.png">
                                </div>
                                <div v-if="!items[5].disabled">
                                    <img src= "./layout_ValignMiddle_normal.png" >
                                </div>
                                <!--<img src="./layout_ValignMiddle_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="底对齐" placement="bottom">
                            <div :class="{active: items[6].active, disabled:items[6].disabled}" @click="handleAliginItemClick(6)">
                                <div v-if="items[6].disabled">
                                    <img src="./layout_ValighBottom_disabled.png">
                                </div>
                                <div v-if="!items[6].disabled">
                                    <img src= "./layout_ValighBottom_normal.png" >
                                </div>
                                <!--<img src="./layout_ValighBottom_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="垂直等距" placement="bottom">
                            <div :class="{active: items[7].active, disabled:items[7].disabled}" @click="handleAliginItemClick(7)">
                                <div v-if="items[7].disabled">
                                    <img src="./layout_ValighJustify_disabled.png">
                                </div>
                                <div v-if="!items[7].disabled">
                                    <img src= "./layout_ValighJustify_normal.png" >
                                </div>
                                <!--<img src="./layout_ValighJustify_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="最近对齐" placement="bottom">
                            <div :class="{active: items[8].active, disabled:items[8].disabled}" @click="handleAliginItemClick(8)">
                                <div v-if="items[8].disabled">
                                    <img src="./layout_ZalighUp_disabled.png">
                                </div>
                                <div v-if="!items[8].disabled">
                                    <img src= "./layout_ZalighUp_normal.png" >
                                </div>
                                <!--<img src="./layout_ZalighUp_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="最远对齐" placement="bottom">
                            <div :class="{active: items[9].active, disabled:items[9].disabled}" @click="handleAliginItemClick(9)">
                                <div v-if="items[9].disabled">
                                    <img src="./layout_ZalighDown_disabled.png">
                                </div>
                                <div v-if="!items[9].disabled">
                                    <img src= "./layout_ZalighDown_normal.png" >
                                </div>
                                <!--<img src="./layout_ZalighDown_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="line" ></div>
                </div>

                <div class="width"><p>统一大小</p></div>
                <div class="Width_container">

                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="水平最短" placement="bottom">
                            <div :class="{active: items[10].active, disabled: items[10].disabled}" @click="handleAliginItemClick(10)">
                                <div v-if="items[10].disabled">
                                    <img src="./layout_WidthMin_disabled.png">
                                </div>
                                <div v-if="!items[10].disabled">
                                    <img src= "./layout_WidthMin_normal.png" >
                                </div>
                                <!--<img src="./layout_WidthMin_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="水平最长" placement="bottom">
                            <div :class="{active: items[11].active, disabled:items[11].disabled}" @click="handleAliginItemClick(11)">
                                <div v-if="items[11].disabled">
                                    <img src="./layout_WidthMax_disabled.png">
                                </div>
                                <div v-if="!items[11].disabled">
                                    <img src= "./layout_WidthMax_normal.png" >
                                </div>
                                <!--<img src="./layout_WidthMax_normal.png">-->
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="垂直最短" placement="bottom">
                            <div :class="{active: items[12].active, disabled: items[12].disabled}" @click="handleAliginItemClick(12)">
                                <div v-if="items[12].disabled">
                                    <img src="./layout_HeightMin_disabled.png">
                                </div>
                                <div v-if="!items[12].disabled">
                                    <img src= "./layout_HeightMin_normal.png" >
                                </div>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <el-tooltip class="item" effect="dark" content="垂直最长" placement="bottom">
                            <div :class="{active: items[13].active, disabled:items[13].disabled}" @click="handleAliginItemClick(13)">
                                <div v-if="items[13].disabled">
                                    <img src="./layout_HeightMax_disabled.png">
                                </div>
                                <div v-if="!items[13].disabled">
                                    <img src= "./layout_HeightMax_normal.png" >
                                </div>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </div>

        <psocket :attributes="attributes" :flashvars="flashvars" v-if="platform == 'qt'"></psocket>
    </div>
</template>
<script>
    // Psocket 组件
    import Psocket from '@/components/Flash/PSocket'
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    // 工具类
    import EUY from '@/common/scripts/euy.js'

    export default {

        name: 'align',
        components:
        {
            Psocket,
        },
        data ()
        {
            return {
                platform: this.$route.query.platform,
                items: [{normal: 'Item 1', active: false, desc: '左对齐', disabled: false},
                    {normal: 'Item 2', active: false, desc: '水平居中对齐', disabled: false},
                    {normal: 'Item 3', active: false, desc: '右对齐', disabled: false},
                    {normal: 'Item 4', active: false, desc: '水平等距', disabled: false},
                    {normal: 'Item 5', active: false, desc: '顶对齐', disabled: false},
                    {normal: 'Item 6', active: false, desc: '垂直居中对齐', disabled: false},
                    {normal: 'Item 7', active: false, desc: '底对齐', disabled: false},
                    {normal: 'Item 8', active: false, desc: '垂直等距', disabled: false},
                    {normal: 'Item 9', active: false, desc: '最近对齐', disabled: false},
                    {normal: 'Item 10', active: false, desc: '最远对齐', disabled: false},
                    {normal: 'Item 11', active: false, desc: '水平最短', disabled: false},
                    {normal: 'Item 12', active: false, desc: '水平最长', disabled: false},
                    {normal: 'Item 13', active: false, desc: '垂直最短', disabled: false},
                    {normal: 'Item 14', active: false, desc: '垂直最长', disabled: false}
                ],
            }
        },

        methods:
        {
            handleAliginItemClick(index) {
                if (this.items[index].disabled) return

                // this.handleItemActive(this.item1s);
                for (var i = 0; i < this.items.length; i++) {
                    this.items[i].active = false;
                }
                this.items[index].active = true;
                let  platform = this.$route.query.platform
                let align_6_44 = {
                    packageId: 0,
                    senderId: ALIGN,
                    senderName: ALIGN_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 44,
                    protoBytesType: 'com.proto.scene.MAlign',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MAlign(), {
                        setType:index
                    })
                }
                // 发送消息
                Protocol.sender(platform, align_6_44)
            },

            handleItemActive(arr) {
                for (var i = 0; i < arr.length; i++) {
                    arr[i].active = false;
                }
            }
        },

        mounted ()
        {
            let  platform = this.$route.query.platform
            let _this = this
            // 模块初始化
            Protocol.onSocketInit(platform, ALIGN_NAME, ALIGN)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, ALIGN_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, ALIGN_NAME, ALIGN)
            window[PAGE_NAME].domReady = () => {
                // 请求同步页数据
                let align_able_6_45 = {
                    packageId: 0,
                    senderId: ALIGN,
                    senderName: ALIGN_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 45,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, align_able_6_45)
            }
            // 接收消息
            Protocol.receiver(platform, ALIGN_NAME)
            window[ALIGN_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {

                if (sessionId == 6 && messageId == 46) {
                    
                    let mBool = Protocol.deserializeBinary('proto.com.proto.s.MBool', protoBytes).toObject();
                    console.log("mBool:", mBool)
                    for (var i = 0;i < this.items.length;i++){
                        this.items[i].disabled = !mBool.value;
                    }
                }else if (sessionId == 6 && messageId == 1) {
                    let align_able_6_45 = {
                        packageId: 0,
                        senderId: ALIGN,
                        senderName: ALIGN_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 45,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, align_able_6_45)
                }
            }
        }
    }
</script>
<style scoped lang="stylus">
    .alignment
        position :flex
        width :280px
        height:100%//500px
        left : 0
        background:#505050
        /*top:20px*/
        .content
            position relative
            top:16px
            left:10px
            width:240px
            /*background blue*/
            /*height :20px*/
            .align
                line-height :25px
                height:25px
                background:#505050
                color:#e2e2e2
                /*background aqua*/
            .Align_container
                position: relative
                left:0
                top:10px
                bottom:40px
                width:280px
                // background:green
                .item
                    display :inline-block
                    width :20px
                    height:20px
                    top:10px
                    // margin-top :2px
                    margin-bottom :13px
                    margin-right :5px
                    margin-left :0px
                    align-content :center
                    .active{
                        &:hover{
                            background:#6d6d6d
                        }
                        &:active{
                            background:#3d3d3d
                        }
                    }
                    .disabled{
                        &:hover{
                            background:#505050//#e8e8e8
                        }
                    }
                    &:hover{
                        background:#6d6d6d
                    }  
                .line
                    position :relative
                    height :1px
                    top:8px
                    margin-left:-10px
                    width :280px
                    /*left:0px*/
                    background :#959595//gray
            .width
                position :relative
                line-height :35px
                height:35px
                /*background blue*/
                top:18px
                margin-bottom :16px
                background:#505050
                color:#e2e2e2
            .Width_container
                position: relative
                left:0
                top:10px
                width:280px
                /*background red*/
                .item
                    display :inline-block
                    width :20px
                    height:20px
                    margin-right :5px
                    margin-left :0px
                    align-content :center
                    .active{
                        //  background:#bdbdbd
                        &:hover{
                            background:#6d6d6d
                        }
                        &:active{
                            background:#3d3d3d
                        } 
                    }
                    .disabled{
                        &:hover{
                            background:#505050//#e8e8e8
                        }
                    }
                    &:hover{
                        background:#6d6d6d
                    }
                        
                        
</style>



// WEBPACK FOOTER //
// Align.vue?5b9e4ffa